import React, { useState } from 'react'
import styled from '@emotion/styled'
import { FlexRowDiv, FlexDiv } from '../../generic/Basics'
import { fontSize3XSmall, greenBase, grayLight40, fontSize2XSmall, fontWeightSemibold, fontWeightBold, highlightBlueBase, grayLight45 } from '../../../constants/principles'
import Icon from '@kbbcomponentlibrary/icon'
import Button from '../../generic/button'
import useSendOffer from '../../../hooks/useSendOffer'
import { StringUtils } from '../../../utils/siteUtils'
import IconCountryOfOrigin from '../../../assets/countryoforigin.svg' //'@kbbcomponentlibrary/icon-country-of-origin'
import IconPhone from '@kbbcomponentlibrary/icon-phone'
import GreenDot from '../../generic/checkDot'
import { breakpoints } from '../../../constants'
import checkmark from '../../../components/vehicleDetails/blackCheck.svg'
import ScheduleAppointmentOverlay from '../ScheduleAppointmentOverlay'
import { Flex } from '../../generic/flex'
import _ from 'lodash'
import { formatPrice } from '../../../utils/kbbUtils'

const DealerIconDiv = ({ dealer, updateGlobalState }) => {
  const phoneString = dealer.dealershipPhone ? StringUtils.formatPhoneString(dealer.dealershipPhone) : dealer.dealershipPhone
  const phoneTag = phoneString && phoneString.replace(/[\W]/g, '')
  const dealerTag = dealer.dealershipName && dealer.dealershipName.slice(0, 50).replace(/[\W]/g, '')

  return (
    <>
      <StyledIconDiv>
        <IconItemDiv>
          <StyledPerson type="LittleGuy" size={18} />
          {dealer.dealerContact}
        </IconItemDiv>
        {dealer.dealershipPhone && (
          <IconItemDiv>
            <StyledPhone size={18} />
            <A href={`tel:${dealer.dealershipPhone}`} onClick={() => updateGlobalState({ fireAnalytics: `tel_${dealerTag}_${phoneTag}_lnk` })}>
              {phoneString}
            </A>
          </IconItemDiv>
        )}
        {dealer.dealerWebAddress && (
          <IconItemDiv>
            <StyledGlobe src={IconCountryOfOrigin} size={18} />
            <A href={dealer.dealerWebAddress} target={'_blank'} onClick={() => updateGlobalState({ fireAnalytics: `sitelink_dealerlink_${dealerTag}_lnk` })}>
              {dealer.dealerWebAddress.split(':')[1].replace('//', '')}
            </A>
          </IconItemDiv>
        )}
      </StyledIconDiv>
    </>
  )
}

const Distance = ({ distance }) => (
  <DistanceDiv>
    {distance} mile{distance !== 1 && 's'} away
  </DistanceDiv>
)

const SendOfferToDealer = ({ offerId, dealer, setDisplayRequestBtn, appointment }) => {
  const [sent, sendOffer] = useSendOffer(offerId)
  if (sent === 'Sent' || (appointment && appointment.isOfferSentToDealer)) {
    setDisplayRequestBtn(true)
  }
  return (
    <SendDiv>
      {sent === 'Sent' || (appointment && appointment.isOfferSentToDealer) ? (
        <StatusDiv>
          <GreenDot color={greenBase} />
          Offer sent to dealer
        </StatusDiv>
      ) : (
        offerId && (
          <SmallButton id={dealer.dealerId} sent={sent} onClick={e => sendOffer(e.target.id)}>
            {sent === 'Sending' ? 'Sending...' : 'Send My Offer to Dealer'}
          </SmallButton>
        )
      )}
    </SendDiv>
  )
}

export default ({ dealer, isDesktop, vehicle, offerId, updateGlobalState, isAllocationEntrie, appointments = [], isAppointmentRequestEnabled, hideDealerAddress, isAssigned }) => {
  const baseImageUrl = (vehicle && vehicle.make && vehicle.vehicleImage && vehicle.vehicleImage.url) || dealer.dealerPhotoUrl
  const fullImageUrl = baseImageUrl && (!StringUtils.hasDomainRegex(baseImageUrl) ? `//s3.amazonaws.com/icoassets.awskbbico.kbb.com${baseImageUrl}` : baseImageUrl)
  const [openReqAppOverlay, setOpenReqAppOverlay] = useState(false)
  const [reqAppDealer, setReqAppDealer] = useState(undefined)
  const appointment = appointments.find(appointment => appointment.dealerId == dealer.dealerId)
  const [appointmentDate, setAppointmentDate] = useState(appointment && appointment.isRequestedAppointment && appointment.acceptAppointmentRequests ? `${appointment.dayOfWeek} ${appointment.timeFrame}` : undefined)
  const acceptAppointmentRequests = isAppointmentRequestEnabled && appointment.acceptAppointmentRequests
  const [displayRequestBtn, setDisplayRequestBtn] = useState(false)
  const phoneString = dealer.dealershipPhone ? StringUtils.formatPhoneString(dealer.dealershipPhone) : dealer.dealershipPhone
  const dealerTag = dealer.dealershipName && dealer.dealershipName.slice(0, 50).replace(/[\W]/g, '')
  const phoneTag = phoneString && phoneString.replace(/[\W]/g, '')

  return (
    <DealerDiv>
      <ScheduleAppointmentOverlay offerId={offerId} showing={openReqAppOverlay} setShowing={setOpenReqAppOverlay} dealer={reqAppDealer} setDealer={setReqAppDealer} setAppointmentDate={setAppointmentDate} updateGlobalState={updateGlobalState} />
      <DealerRowOnDesktop flex={1} width="100%">
        <Flex flex={1} flexDirection="column">
          <Flex flex={1}>
            {fullImageUrl && <StyledImg alt="dealership" src={fullImageUrl} />}
            <div>
              <TextDiv fontWeight={fontWeightBold}>{dealer.dealershipName}</TextDiv>
              {hideDealerAddress ? null : <DealerAddress dealer={dealer} />}
            </div>
          </Flex>
          <DealerIconDiv dealer={dealer} updateGlobalState={updateGlobalState} />
        </Flex>
        <Flex flexDirection="column" justifyContent="flex-start">
          {!isAllocationEntrie && !appointmentDate && <SendOfferToDealer {...{ offerId, dealer, setDisplayRequestBtn, updateGlobalState, appointment }} />}

          {acceptAppointmentRequests && (isAllocationEntrie || displayRequestBtn || appointmentDate) && (
            <DealerRequestAppDiv class="col">
              {!appointmentDate ? (
                <SmallButton
                  data-testid={`oc-btn-request-appointment-lst`}
                  onClick={() => {
                    setReqAppDealer(dealer)
                    setOpenReqAppOverlay(true)
                    updateGlobalState({ fireAnalytics: `Req_Appt_${dealerTag}_${phoneTag}_btn` })
                  }}>
                  Request Appointment
                </SmallButton>
              ) : (
                <StatusDiv>
                  <GreenDot color={greenBase} />
                  {appointmentDate ? `Request Sent: ${appointmentDate}` : 'Appointment Requested'}
                </StatusDiv>
              )}
            </DealerRequestAppDiv>
          )}
        </Flex>
      </DealerRowOnDesktop>
      {isAssigned > 0 && vehicle && vehicle.filter(v => v.price > 0).length > 0 && (
        <VehicleInventory>
          {_.chunk(vehicle, 3).map(chunk => (
            <FullWidthRow>{chunk.map(v => v.price > 0 && <DealerVehicle vehicle={v} />)}</FullWidthRow>
          ))}
        </VehicleInventory>
      )}
    </DealerDiv>
  )
}

const DealerVehicle = ({ vehicle: { vehicleImage, vehicleType, year, make, model, price, detailsUrl } }) => {
  const fullImageUrl = vehicleImage.url && (!StringUtils.hasDomainRegex(vehicleImage.url) ? `//s3.amazonaws.com/icoassets.awskbbico.kbb.com${vehicleImage.url}` : vehicleImage.url)
  return (
    <VehicleDiv>
      {fullImageUrl && <StyledImg alt="vehicle" src={fullImageUrl} />}
      <div>
        <TextDiv fontWeight={fontWeightSemibold}>
          {vehicleType} {year} {make} {model}
        </TextDiv>
        <TextDiv fontWeight={fontWeightBold}>{formatPrice(price)}</TextDiv>
        <A href={detailsUrl} target="_blank">
          View details
        </A>
      </div>
    </VehicleDiv>
  )
}

const DealerAddress = ({ dealer }) => {
  return (
    <>
      <div>{dealer.dealershipAddress}</div>
      <div>
        {dealer.dealershipCity}, {dealer.dealershipState} {dealer.dealershipZipCode}
      </div>
      <Distance distance={dealer.distance} />
    </>
  )
}

const FullWidthRow = styled(Flex)`
  width: 100%;
  flex-direction: column;
  @media (min-width: ${breakpoints.mid}px) {
    flex-direction: row;
  }
`
const VehicleInventory = styled(Flex)`
  text-align: left;
  flex-direction: column;
  width: 100%;
  border-top: 1px solid ${grayLight45};
`
const VehicleDiv = styled(Flex)`
  float: left;
  padding: 10px 0px;
  width: 100%;

  @media (min-width: ${breakpoints.mid}px) {
    width: 33.3333%;
  }
`
const SmallButton = styled(Button)`
  font-size: ${fontSize2XSmall};
  padding: 8px;
  margin-top: 8px;
`
const StatusDiv = styled.div`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightSemibold};
  padding: 4px 8px;
  margin-top: 8px;
  margin-left: -12px;
  display: flex;
  align-items: center;
`
const StyledIconDiv = styled.div`
  font-weight: ${fontWeightSemibold};
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (min-width: ${breakpoints.lg}px) {
    display: block;
  }
  width: 100%;
`
const IconItemDiv = styled.div`
  padding-right: 24px;
  display: inline;
`
const TextDiv = styled.div`
  font-weight: ${p => p.fontWeight};
  font-size: ${p => p.fontSize};
`
const DealerDiv = styled(FlexRowDiv)`
  font-size: ${fontSize2XSmall};
  padding: 16px 0px;
  border-bottom: 3px solid ${grayLight40};
  text-align: left;
  flex: 1;
  flex-direction: column;
  width: 100%;
`
const DealerInfoDiv = styled.div`
  padding-right: 8px;
`
const DealerTileDiv = styled.div``

const DealerRequestAppDiv = styled.div``

const StyledImg = styled.img`
  max-width: 100px;
  align-self: flex-start;
  @media (min-width: ${breakpoints.lg}px) {
    align-self: flex-start;
  }
  margin-right: 8px;
`
const StyledPerson = styled(Icon)`
  vertical-align: bottom;
  margin-right: 5px;
`
const StyledPhone = styled(IconPhone)`
  vertical-align: bottom;
  margin-right: 5px;
`
const StyledGlobe = styled.img`
  width: 18px;
  height: 18px;
  vertical-align: bottom;
  margin-right: 5px;
`
const DistanceDiv = styled.div`
  font-size: ${fontSize3XSmall};
  padding-top: 8px;
`
const SendDiv = styled.div`
  @media (min-width: ${breakpoints.lg}px) {
    margin-left: auto;
  }
  display: flex;
`
const A = styled.a`
  text-decoration: none;
  color: ${highlightBlueBase};
  :hover {
    text-decoration: underline;
  }
`
const DealerRowOnDesktop = styled(Flex)`
  flex-direction: column;
  padding-bottom: 10px;
  @media (min-width: ${breakpoints.mid}px) {
    flex-direction: row;
  }
`
